const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-trash{fill:none;stroke:#707070;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.5 -2)"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon-trash",
  d: "M4.5,9H24.357",
  transform: "translate(0 -1.587)"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-trash",
  d: "M22.944,7.413V22.857a2.206,2.206,0,0,1-2.206,2.206H9.706A2.206,2.206,0,0,1,7.5,22.857V7.413m3.309,0V5.206A2.206,2.206,0,0,1,13.016,3h4.413a2.206,2.206,0,0,1,2.206,2.206V7.413",
  transform: "translate(-0.794)"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-trash",
  d: "M15,16.5v6.619",
  transform: "translate(-2.778 -3.572)"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-trash",
  d: "M21,16.5v6.619",
  transform: "translate(-4.365 -3.572)"
}));
function SvgIconfeatherTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.857,
    height: 24.063,
    viewBox: "0 0 21.857 24.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherTrash);
export default __webpack_public_path__ + "static/media/Icon feather-trash.274fd183.svg";
export { ForwardRef as ReactComponent };